<div *ngIf="errorMessage != null" >
  <span class="glyphicon glyphicon-remove form-control-feedback" style="margin-right: 10px;"></span>
  <span class="sr-only">(error)</span>
  <div class="errorDiv">
    {{ errorMessage }}
  </div>
</div>